import * as React from 'react';
import { Image } from '../../api';
import './ImageChooser.css';

export interface IImagePlaceholderProps {
    image?: Image;
    text?: string;
}

export default class ImagePlaceholder extends React.PureComponent<IImagePlaceholderProps> {
    public render() {
        const { image, text } = this.props;

        let style = {};
        let url;
        if (image) {
            url = image.ThumbnailURL;
        }

        if (url) {
            style = {
                backgroundImage: 'url(' + url + ')',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain',
                backgroundPosition: 'center'
            };
        }

        return (
            <div className="imagePlaceholder">
                {text}
                <div className="imageHolder" style={style} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/imageChooser/ImagePlaceholder.tsx